import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import TableEmptyState from '../ReusableComponents/TableEmptyState';
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaVideo } from "react-icons/fa";
import { MdDelete, MdFileDownload, MdModeEdit, MdVideoLibrary } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFilePdfFill, BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import { saveAs } from 'file-saver';
import { STORAGE_URL, URL } from "../../variables";



const TextosApoio = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(false);
  const [loading_textos, setLoadingtextos] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [textos, settextos] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { processo_id, redacao_name } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [textos_id, setRedacaoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const Gettextos = async (page, search) => {

    let response = await Request.Get(`faculdade/get_textos/${processo_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {

      settextos(response.textos);

      setPagination(response.pagination);
      setLoadingScreen(false);
      setLoadingtextos(false);


    }
  };






  const DeleteRedacao = async (textos_id) => {

    let response = await Request.Delete(`faculdade/desvincular_texto/${textos_id}/${processo_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Gettextos(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    // Gettextos(1, search_oficial);
    settextos(props.textos);
  }, []);

  let pesquisarTimeout = null;
  const history = useHistory();
  return (
    <div className="row">

            <div className="col-12">


                {/* <hr /> */}
                {loading_screen == false && <div>
                    <p className="text-muted">{t("ui_aqui_ficam_os_textos_de_apoio_da_redacao_f7a787bd")}{redacao_name}"</p>

                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}



                    <div className="table-modern-card">
                        <div className="table-modern-scroll mb-0">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>{t("legacy_titulo")}</th>
                                        <th data-priority="3">PDF</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {loading_textos == false && textos.map((item, id) =>

                  <tr key={id}>
                                            <td>{item.titulo}</td>

                                            {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}

                                            <td>
                                            <div className="actions-group">
                                            <a target="_blank" href={STORAGE_URL + item.arquivo} title={t("legacy_visualizar_texto")}>
                                                <span className="action-btn danger">
                                                    <BsFilePdfFill />
                                                </span>
                                                </a>



                                            </div>
                                            </td>

                                        </tr>
                  )}

                                </tbody>
                            </table>
                            {loading_textos == true &&
              <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                    </div> */}
                                    <CircularProgress />
                                </div></div>

              }
                        </div>
                    </div>
                    {loading_textos == false && textos.length == 0 && <div className="row">
                        <div className="col-12">
                            <TableEmptyState title={t("legacy_nenhuma_texto_encontrada")} icon="✍️" />

                        </div>
                    </div>}



                    {/* {this.state.andamento == true && <AvaliacaoAndamento get_textos={this.get_textos.bind(this)} {...this.props} />} */}

                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
              </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
          warning
          title={t("legacy_atencao")}
          onConfirm={() => {
            setShowWarning(false);
            setLoadingtextos(true);
            DeleteRedacao(textos_id);
            // this.delete_banner(this.state.banner_to_delete);
          }}
          onCancel={() => {
            setShowWarning(false);
          }}
          show={show_warning}
          confirmBtnText={t("ui_sim_desejo_desvincular_91364237")}
          cancelBtnText={t("legacy_cancelar")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          showCancel={true}>{t("ui_ao_desvincular_este_texto_ele_nao_tera_mais_acesso_0fb3b0af")}


        </SweetAlert>


            </div>

        </div>);

};

export default TextosApoio;
